declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

/**
 * Send an engagement event through the Google tag initialized in index.html.
 * GA4's Enhanced Measurement handles initial and client-side page views.
 */
export function trackEvent(name: string, params?: Record<string, unknown>) {
  window.gtag?.('event', name, params)
}
